import { FC } from 'react';
import { useParams, useLocation} from 'react-router-dom';
import { useState, useEffect   } from 'react';
import { AddGuestInfoContainer } from './style';

import PhoneNumberInput from 'components/PhoneNumberInput';
import FormInputField from 'components/FormInputField';
import { colors } from 'constants/colors';
import StyledButton from 'components/Button';
import NumberInputWithButtons from "components/NumberInputWithButtons";
import { useLoadTrips } from 'customHooks/useLoadTrips';
import { useSetRecoilState} from 'recoil';

import {useChangeGuestInfo} from 'customHooks/useChangeGuestInfo';
import { useHistory } from 'react-router-dom'

import { reloadTrips } from  'states/CommonStates/atoms';
import useWindowSize from 'customHooks/useWindowSize'
import { styleSizesNumber } from "constants/styleSizes";

const debug = false;

type GuestInfoDraft = {
  phoneNumber: string;
  fullName: string;
  numberOfRoomKeys: number;
};


const AddGuestInfoContent: FC = () => {


    // Add or Edit guests...
    const location = useLocation();
    const isEditMode = location.pathname.includes('/edit-guest-info/');
    const setReloadTrips = useSetRecoilState(reloadTrips);
    
  
  const { width:windowWidth } = useWindowSize()

  const { handleChangeGuestInfo } = useChangeGuestInfo(() => {
    // Refething data on success information change by callback
    //refetch();
    setReloadTrips(true);
    goToNextRoom ();
  });

  const history = useHistory()

  const { trips, loading } = useLoadTrips()

  const { groupId, roomId } = useParams<{ groupId: string; roomId: string }>();

  const roomIdNumber = Number(roomId);
  const roomNumber = roomIdNumber;

  const guestInfoDraftKey = `addGuestInfoDraft:${groupId}:${roomNumber}`;

  const [phoneNumber, setPhoneNumber] = useState('');

  const [numberOfKeysValue, setNumberOfKeysValue] = useState(1);



  const [newPhoneNumberErrorMessage, setNewPhoneNumberErrorMessage] = useState(false);
  const [newPhoneNumberErrorMessageText] = useState('Please enter valid phone number.');

  const [newPhoneNumber, setNewPhoneNumber] = useState('');
  const [numberOfRooms, setNumberOfRooms] = useState(0);


  const [errorMessageFullName, setErrorMessageFullName] = useState(false);
  const [errorMessageFullNameText, setErrorMessageFullNameText] = useState('Please enter correct Full name.');
  const [fullNameValue, setFullNameValue] = useState('');

  const [roomType, setRoomType] = useState('');
  const [roomFeatures, setRoomFeatures] = useState('');

  const saveGuestInfoDraft = (draft: Partial<GuestInfoDraft>) => {
    if (isEditMode) return;
  
    sessionStorage.setItem(
      guestInfoDraftKey,
      JSON.stringify({
        phoneNumber: draft.phoneNumber ?? newPhoneNumber,
        fullName: draft.fullName ?? fullNameValue,
        numberOfRoomKeys: draft.numberOfRoomKeys ?? numberOfKeysValue,
      })
    );
  };


  useEffect(() => {
    const booking = trips[groupId]?.bookings?.[roomNumber - 1];

    if (!booking) return;

    if (debug) {
      console.log('Current guest room:', roomNumber);
    }

    setNumberOfRooms(trips[groupId]?.bookings?.length || 0);
    // setPhoneNumber(booking.phoneNumber || '');
    // setNewPhoneNumber(booking.phoneNumber || '');
    // setFullNameValue(booking.fullName || '');
    // setRoomType(booking.roomBookings?.[0]?.room?.roomType?.name || '');
    // setRoomFeatures(booking.roomBookings?.[0]?.room?.roomType?.bed || '');
    // setNumberOfKeysValue(booking.numberOfRoomKeys || 1);

    let draft: Partial<GuestInfoDraft> | null = null;

    if (!isEditMode) {
      const savedDraft = sessionStorage.getItem(guestInfoDraftKey);

      if (savedDraft) {
        try {
          draft = JSON.parse(savedDraft) as Partial<GuestInfoDraft>;
        } catch {
          sessionStorage.removeItem(guestInfoDraftKey);
        }
      }
    }

    const initialPhoneNumber = draft?.phoneNumber ?? booking.phoneNumber ?? '';

    setPhoneNumber(initialPhoneNumber);
    setNewPhoneNumber(initialPhoneNumber);
    setFullNameValue(draft?.fullName ?? booking.fullName ?? '');
    setRoomType(booking.roomBookings?.[0]?.room?.roomType?.name || '');
    setRoomFeatures(booking.roomBookings?.[0]?.room?.roomType?.bed || '');
    setNumberOfKeysValue(draft?.numberOfRoomKeys ?? booking.numberOfRoomKeys ?? 1);

    setNewPhoneNumberErrorMessage(false);
    setErrorMessageFullName(false);
  }, [trips, groupId, roomNumber, isEditMode, guestInfoDraftKey]);



  if (debug) {
    console.log ("groupId from add gues information: ", groupId);
    console.log ("roomId from add gues information: ", roomId);
  }


  // const goToNextRoom = () => {

  //   if (isEditMode) {
  //     window.history.pushState(
  //       null,
  //       '',
  //       `/account/bookings/add-guest-info/${groupId}/${roomNumber}`
  //     );
  //     history.push(`/account/bookings/guest-information/${groupId}`);
  //   }
  //   else {

  //     if (roomNumber < trips[groupId]?.bookings.length) {
  //       //FIXME: Need to add back next buttons functionallity
  //         window.history.pushState(
  //           null,
  //           '',
  //           `/account/bookings/add-guest-info/${groupId}/${roomNumber}`
  //         );
  //         setRoomNumber((prevRoomNumber) => (prevRoomNumber + 1));
  //       }
  //       else {
  //         window.history.pushState(
  //           null,
  //           '',
  //           `/account/bookings/add-guest-info/${groupId}/${roomNumber}`
  //         );
  //         history.push(`/account/bookings/guest-information/${groupId}`);
  //       }

  //   }

  // }

  const goToNextRoom = () => {

    if (!isEditMode) {
      sessionStorage.removeItem(guestInfoDraftKey);
    }

    if (isEditMode) {
      history.push(`/account/bookings/guest-information/${groupId}`);
      return;
    }
  
    const nextRoomNumber = roomNumber + 1;
  
    if (nextRoomNumber <= trips[groupId]?.bookings.length) {
      history.push(`/account/bookings/add-guest-info/${groupId}/${nextRoomNumber}`);
    } else {
      history.push(`/account/bookings/guest-information/${groupId}`);
    }
  };
  
  const addNextGuest = () => {

    let noErrors = true;

    if (fullNameValue.length < 2) {
      setErrorMessageFullNameText("Please, enter correct Full name.");
      setErrorMessageFullName(true);
      noErrors = false;
    }

    if (!/^[+][0-9]{8,14}$/.test(newPhoneNumber)) {
      setNewPhoneNumberErrorMessage(true);
      noErrors = false;
      if (debug) {
        console.log('Phone number is incorrect...');
      }
    } else {
      if (debug) {
        console.log('Phone number is correct!');
      }
    }


    if (noErrors) {
      if (newPhoneNumber !== trips[groupId]?.bookings[roomNumber - 1]?.phoneNumber ||
        fullNameValue !== trips[groupId]?.bookings[roomNumber - 1]?.fullName ||
        numberOfKeysValue !== trips[groupId]?.bookings[roomNumber - 1]?.numberOfRoomKeys
      )
        {
          if (debug) {
            console.log ("Sending data booking Id:", trips[groupId]?.bookings[roomNumber - 1]?.bookingId, "numberOfKeysValue: ", numberOfKeysValue, "fullNameValue: ", fullNameValue, "phoneNumber: ", newPhoneNumber);
          }
          handleChangeGuestInfo(trips[groupId]?.bookings[roomNumber - 1]?.bookingId, numberOfKeysValue, fullNameValue, newPhoneNumber);
          
        }
      else {
        if (debug) {
          console.log ("Data not changed... moving to next room");
        }
        goToNextRoom ();
      }
    }
  }

  if (isNaN(roomIdNumber)) {
    return <div>Error: Invalid roomId</div>;
  }

  if (loading || !trips) {
    return (
      <AddGuestInfoContainer>
      <div className="accountBody">
        {/* <div className="loading">Loading...</div> */}
      </div>
      </AddGuestInfoContainer>
    );
  }

  

  return (
    <AddGuestInfoContainer>



      <div className="accountBody">
        <div className="cardContent">
          <h2 className="room">Room {roomNumber}/{numberOfRooms}</h2>
          <div className="roomOptions">
            <div className="roomType">
              <div className="optionTitle">ROOM TYPE</div>
              <div className="optionContent">{roomType}&nbsp;</div>
            </div>
            <div className="roomFeatures">
              <div className="optionTitle">ROOM FEATURES</div>
              <div className="optionContent">{roomFeatures}&nbsp;</div>
            </div>
            {windowWidth <= styleSizesNumber.tabletBreakpoint ? (
              <div className="roomFeatures roomFeaturesNumberOfKeys">
                <div className="roomFeatures">
                <div className="optionTitle"># OF ROOM KEYS </div>
                <div className="optionContent">
                  <div className="numberOfKeysCel">
                    <NumberInputWithButtons
                      min={1}
                      max={2}
                      value={numberOfKeysValue}
                      onChange={(value) => {
                        setNumberOfKeysValue(value);
                        saveGuestInfoDraft({ numberOfRoomKeys: value });
                      }}
                      errorMessage={undefined}
                    />
                  </div>
                </div>
                </div>
              </div>

            ) : null
            }
          </div>
          <div className="roomForm">
            <div className="formBody">
              <div className="phoneCel">
              <PhoneNumberInput
                    key={`${roomNumber}-${phoneNumber || "empty"}`} // refresh initialValue once phone changed
                    initialValue={phoneNumber}
                    className='phoneNumberInput'
                    label="GUEST PHONE"
                    isRequired={true}
                    labelPosition='left'
                    error={newPhoneNumberErrorMessage}
                    errorMessage={newPhoneNumberErrorMessageText}
                    inputHeight="49px"
                    marginBottom={'20px'}
                    onChangeNumber={(newNumber) => {
                      if (debug) {
                        console.log ("newNumber=", newNumber);
                      }
                      setNewPhoneNumber(newNumber);
                      saveGuestInfoDraft({ phoneNumber: newNumber });
                      if (newNumber!==newPhoneNumber) {
                        setNewPhoneNumberErrorMessage(false);
                      }
                      
                    }}
                  />                
              </div>
              <div className="nameCel">
                <FormInputField
                  className="secInput"
                  // highLightLabel='CURRENT '
                  label="GUEST NAME"
                  isRequired
                  type="text"
                  borderColor={colors.signInBorderColor}
                  error={errorMessageFullName}
                  errorMessage={errorMessageFullNameText}
                  // value={oldPassword}
                  inputHeight="48px"
                  marginBottom="20px"
                  value={fullNameValue}
                  maxLength={300}
                  onChange={(e) => {
                    const newFullName = e.target.value;

                    setErrorMessageFullName(false);
                    setFullNameValue(newFullName);
                    saveGuestInfoDraft({ fullName: newFullName });
                  }}
                />
              </div>
              {windowWidth > styleSizesNumber.tabletBreakpoint ? (
              <div className="numberOfKeysCel">
                <NumberInputWithButtons
                  min={1}
                  max={2}
                  value={numberOfKeysValue}
                  onChange={(value) => {
                    setNumberOfKeysValue(value);
                    saveGuestInfoDraft({ numberOfRoomKeys: value });
                  }}
                  errorMessage={undefined}
                />
              </div>
            ) : null
            }
            </div>
            <div className="formControls">
              <StyledButton
                width={isEditMode ? "180px" : roomNumber === numberOfRooms ? "110px" : "161px"}
                height="48px"
                disabledBackgroundColor={colors.signInBorderColor}
                disabledColor={colors.white}
                onClick={() => {
                  addNextGuest();
                }}
              >
                {isEditMode ? "Update Information" : roomNumber === numberOfRooms ? "Continue" : "Add Next Guest"}
              </StyledButton>
            </div>
          </div>

        </div>
      </div>
    </AddGuestInfoContainer>
  );
};

export default AddGuestInfoContent;
